/**
 * Created by vedi on 19/03/2017.
 */

import circle from './circle';
import container from './container';
import creepActions from './creepActions';
import creepBuildBody from './creepBuildBody';
import disappear from './disappear';
import draw from './draw';
import moveTo from './moveTo';
import object from './object';
import powerInfluence from './powerInfluence';
import resourceCircle from './resourceCircle';
import road from './road';
import runAction from './runAction';
import say from './say';
import setBadgeUrls from './setBadgeUrls';
import siteProgress from './siteProgress';
import sprite from './sprite';
import terrain from './terrain';
import text from './text';
import userBadge from './userBadge';
import creepDecoration from './creepDecoration';
import objectDecoration from './objectDecoration';

export default {
    circle,
    container,
    creepActions,
    creepBuildBody,
    disappear,
    draw,
    moveTo,
    object,
    powerInfluence,
    resourceCircle,
    road,
    runAction,
    say,
    setBadgeUrls,
    siteProgress,
    sprite,
    terrain,
    text,
    userBadge,
    creepDecoration,
    objectDecoration,
};
